<template>
  <div class="container-fluid search-page rfo-page rfo-page--standard oa-workspace">
    <div class="oa-page-toolbar">
      <router-link :to="{ name: 'pay-operations-manual-assignment' }" class="oa-back-link">
        <i class="fa fa-arrow-left me-1"></i>Back to Manual Assignment
      </router-link>
      <h4 class="mb-0"><i class="fa fa-tags me-2"></i>Assignment Session</h4>
    </div>
    <p class="text-muted font-monospace">Session ID: {{ sessionId }}</p>

    <div v-if="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading session…</span>
      </div>
      <p class="mt-2">Loading…</p>
    </div>
    <div v-else-if="error" class="alert alert-danger outline">{{ error }}</div>
    <div v-else-if="!session" class="oa-empty-state">
      <i class="fa fa-search fa-2x"></i>
      <p class="mb-0">This session could not be found. It may belong to another environment.</p>
    </div>
    <StepResult v-else :session="session" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import StepResult from './components/StepResult.vue';
import { useAssignmentSession } from './composables/useAssignmentSession';

const route = useRoute();
const sessionId = String(route.params.sessionId);
const isLoading = ref(false);
const error = ref<string | null>(null);
const { load, session } = useAssignmentSession();

onMounted(async () => {
  isLoading.value = true;
  try {
    await load(sessionId);
  } catch (e: any) {
    error.value = e?.response?.data?.message ?? e?.message ?? 'Failed to load session';
  } finally {
    isLoading.value = false;
  }
});
</script>
